<template>
  <div class="layout-authi grey lighten-5">
    <!-- <div height class="layout-auth layout-auth-background"></div> -->
    <v-layout wrap>
      <v-flex>
        <Login />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Login from "./login";
export default {
  components: {
    Login,
  },
  data() {
    return {};
  },
};
</script>
<style lang="sass" scoped>
.layout-auth

    height: 60%
    width: 100%
    position: absolute
    top: 0
    left: 0
    content: ""
    z-index: 0

.layout-authi

    height: 100%
    width: 100%
</style>
<style >
.layout-authi {
  height: 100%;
  width: 100%;
}
</style>